<template>
<div>
  <v-dialog v-model="show_detail"
            scrollable
            persistent
            max-width="800"
  >
    <v-card >
      <div
          style="position: absolute;left: 5px;top: 5px;"
          @click="show_detail=false;$emit('close');"
      >
        <svg width="44" height="44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="44" height="44" rx="22" class="back-btn"/>
          <path d="M28.6665 22.2285C28.6665 22.5449 28.4314 22.8064 28.1263 22.8478L28.0415 22.8535L15.5415 22.8535C15.1963 22.8535 14.9165 22.5737 14.9165 22.2285C14.9165 21.9121 15.1516 21.6506 15.4567 21.6092L15.5415 21.6035L28.0415 21.6035C28.3867 21.6035 28.6665 21.8833 28.6665 22.2285Z" fill="black"/>
          <path d="M21.024 26.8059C21.2686 27.0495 21.2695 27.4452 21.0259 27.6898C20.8045 27.9122 20.4573 27.9331 20.2122 27.7521L20.142 27.6917L15.1004 22.6717C14.8773 22.4497 14.857 22.1012 15.0395 21.8562L15.1003 21.786L20.142 16.7652C20.3866 16.5216 20.7823 16.5224 21.0259 16.767C21.2473 16.9893 21.2667 17.3366 21.0847 17.5809L21.024 17.6509L16.4273 22.2291L21.024 26.8059Z" fill="black"/>
        </svg>
      </div>
      <v-card-title class="mb-5 w-100">
        <v-tooltip left color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-avatar v-bind="attrs" v-on="on" size="70">
              <v-img :src="order.created_user.profile_picture"></v-img>
            </v-avatar>
          </template>
          <div>
            ایجاد شده توسط
            {{order.created_user.get_full_name}}
          </div>
        </v-tooltip>
        <h4 class="mx-auto">{{ order.title }}</h4>
      </v-card-title>
      <v-card-text class="container" id="order_content">

        <h3>موارد خرید : </h3>
        <p class="text-justify mx-4 mt-2">{{order.items}}</p>

        <v-divider class="my-5"></v-divider>

        <h3>توضیحات : </h3>
        <p class="text-justify mx-4 mt-2">{{order.des}}</p>

        <v-divider class="my-5"></v-divider>

        <div class="row text-center">
          <v-col><h3>مکان : {{order.location}}</h3></v-col>
        </div>
        <v-divider class="my-5"></v-divider>
        <div>
          <div>
            <h3 class="d-inline">وضعیت :</h3>
            <v-stepper alt-labels :value="order.step" flat>
              <v-stepper-header>
                <v-stepper-step step="0" :complete="order.step == 'Created' || order.step == 'Processing' || order.step == 'Finish'">
                  ثبت شده
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="1" :complete="order.step == 'Processing' || order.step == 'Finish'">
                  در حال انجام
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="4" :complete="order.step == 'Finish'">
                  در حال انجام
                </v-stepper-step>
              </v-stepper-header>
            </v-stepper>
          </div>
        </div>
      </v-card-text>
      <v-card-actions v-if="$GLOBAL_DATA.user['degree'] >= 2 && !order['ended_at']">
        <v-row class="ma-5 mt-0">
          <v-col>
            <v-btn block large outlined
                   v-if="$GLOBAL_DATA.user['degree'] >= 2"
                   class="elevation-0 rounded-0 text-bold"
                   @click="order.step=order.step==='Created'?'Processing':'Finish';update_order_step()"
                   color="warning"
                   :loading="loading"
                   :disabled="loading">
              تغییر وضعیت به
              {{ steps[order.step==='Created'?'Processing':'Finish']}}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn block large text
                   v-if="order.step==='Processing'"
                   class="elevation-0 rounded-0 text-bold"
                   @click="order.step='Created';update_order_step()"
                   color="red"
                   :loading="loading"
                   :disabled="loading">
              بازگشت وضعیت به
              {{ steps['Created'] }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-actions v-else-if="order['ended_at']" class="text-center">
        <div  class="py-5 text-center font-bold mx-auto" style="font-size:  1.4em">
          پایان یافته در تاریخ
          <strong>{{new Date(order['ended_at'].split('T')[0]).toLocaleDateString('fa-IR')}}</strong>
          ساعت
          <strong>{{convert_en_to_fa_number(order['ended_at'].split('T')[1].slice(0,5)) }}</strong>
        </div>
      </v-card-actions>
    </v-card>

  </v-dialog>
</div>
</template>

<script>
import axios from "axios";

export default {
  name: "order-detail",
  props:['order', 'show_detail'],
  data:()=>({
    key: localStorage.getItem('key'),
    loading:false,
    steps : {
      Created: 'ثبت شده',
      Processing: 'در حال انجام' ,
      Finish: 'پایان یافته',
    },

  }),
  methods:{
    update_order_step(){
      this.loading = true;
        axios
            .put(`${this.BACKEND_LINK}/api/shop-order/${this.order.id}`, this.order,{
              headers: {'Authorization': `Token ${this.key}`}
            })
            .then((response)=>{
                if(response.data){
                  this.$snotify.success('با موفقیت ثبت شد', 'وضعیت');
                  this.show_detail=false;
                  this.$emit('close');
                }
                else {
                  this.$snotify.warning('مشکلی در ویرایش وجود دارد.');
                }
            })
            .catch(()=>{
              this.$snotify.error('مشکلی در ویرایش وجود دارد.');
            })
            .finally(()=>{
              this.loading = false;
            })
    },
  },
}
</script>